var Payments = function() {
    var modalData = {};
    var showPaymentsModal;

    var orderByCoupon = function() {
        $('#redeem_coupon_btn').prop('disabled', true);
        Ajax.orderByCoupon($('#coupon').val(), function(res) {
            $('#coupon_response').hide();
            if (res == undefined || res['success'] == undefined || res['success'] != 'ok') {
                $('#coupon_response').show('slow');
                $('#redeem_coupon_btn').prop('disabled', false);
                return;
            }
            window.top.location.href = '/premium?s=1';
            MobileApp.message('coupon_success');
        });
    };

    var orderBySms = function(ref) {
        $('#redeem_sms_btn').prop('disabled', true);
        Ajax.orderBySms($('#sms_pin').val(), ref, function(res) {
            $('#sms_response').hide();
            if (res == undefined || res['success'] == undefined || res['success'] != 'ok') {
                $('#sms_response').show('slow');
                $('#redeem_sms_btn').prop('disabled', false);
                return;
            }
            window.top.location.href = '/premium?s=1';
        });
    };

    var showPins = function() {
        $('#pin_response').html('<i class="fas fa-spin fa-spinner" style="font-size: 26px;"></i>');
        Ajax.showPins($('#phone_number').val(), function(res) {
            if (res && res['success'] == 'ok') {
                $('#pin_response').html(res['pins']);
            }
        });
    };

    var registerSMSModalHandlers = function() {
        $('#redeem_coupon_btn').click(function() {
            orderByCoupon();
        });

        $('#redeem_sms_btn').click(function() {
            var ref = $(this).data('ref');
            orderBySms(ref);
        });

        $('#sms_modal_close_btn').click(function() {
            var ref = $(this).data('ref');
            showPaymentsModal(true, ref);
        });
    };

    showPaymentsModal = function(force, ref) {
        Ajax.recordFunnel(0, 1);
        Modal.showModal(
            'payments_modal',
            modalData,
            function() {
                $('#planbtn').click(function() {
                    var plan = $('input[name=time]:checked').val();
                    if (plan == 'sms') {
                        Modal.showModal(
                            'sms_payment_modal',
                            {ref: ref},
                            function() {
                                registerSMSModalHandlers();
                            },
                            false,
                            false,
                            true
                        );
                    } else {
                        if (Common.isLoggedin) {
                            window.top.location.href = '/premiumpay?am=' + plan + '&ref=' + ref;
                        } else {
                            Common.showRegisterLoginModal();
                        }
                    }
                });
            },
            function() {
                $('.carousel--modal').slick('unslick');
            },
            function() {
                $('.carousel--modal').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    speed: 300,
                    arrows: false,
                    dots: true,
                    lazyLoad: 'progressive',
                });
            },
            force
        );
    };

    return {
        init: function() {
            $('#paybtn').click(function() {
                var method = $('input[name=paymethod]:checked').val();
                var plan = $('#plan').val();

                if (method == 'paypal') {
                    window.top.location.href = '/order_by_paypal?plan=' + plan + '&csrf_token=' + window.csrf['csrf_token'];
                } else
                if (method == 'viva') {
                    Modal.showConfirmModal('Συμφωνώ με τους <b><a href="/terms" target="_blank">Όρους Xρήσης</a></b> της υπηρεσίας.', function() {
                        window.top.location.href = '/order_by_viva?plan=' + plan + '&csrf_token=' + window.csrf['csrf_token'];
                    }, 'Αποδοχή όρων χρήσης');
                }
            });

            $('#redeem_coupon_btn').click(function() {
                orderByCoupon();
            });

            $('#redeem_sms_btn').click(function() {
                orderBySms();
            });

            $('#show_pins_btn').click(function() {
                showPins();
            });
        },
        initPremiumModal: function(data) {
            modalData = data;
            $('body').on('click', '.ii__premium_modal_btn', function() {
                var ref = $(this).data('ref');
                showPaymentsModal(false, ref);
            });
        },
        initPaymentsHistory: function() {
            $('[data-tablebreak]').each(function () {
                var breakpoint = $(this).data('tablebreak');
        
                $(this).basictable({
                    breakpoint: breakpoint,
                });
            });
        }
    };
}();
